export default __webpack_public_path__ + "images/16Spinner.svg";